var map = {
	"./apple-touch-icon-retina.png": 1734,
	"./apple-touch-icon.png": 1735,
	"./chatdesk-logo.png": 1736,
	"./chatdesk_video_thumbnail.png": 751,
	"./check-mark.png": 1737,
	"./delighted.png": 1738,
	"./facebook.png": 710,
	"./favicon16.png": 1739,
	"./favicon32.png": 1740,
	"./favicon48.png": 1741,
	"./front.png": 713,
	"./gladly.png": 1742,
	"./gorgias.png": 1743,
	"./helpscout.png": 714,
	"./icon_business.png": 242,
	"./icon_gladly.png": 752,
	"./icon_gorgias.png": 753,
	"./icon_lock.png": 1744,
	"./icon_reamaze.png": 754,
	"./icon_shopify.png": 755,
	"./icon_status_green.png": 756,
	"./icon_status_red.png": 757,
	"./icon_status_yellow.png": 758,
	"./icon_twitter.png": 1745,
	"./icons/icon_thumbs_up.png": 759,
	"./instagram.png": 711,
	"./kustomer.png": 760,
	"./live_agent.png": 1746,
	"./logos/logo_dixa.png": 521,
	"./logos/logo_reamaze.png": 342,
	"./logos/logo_tiktok_shop.png": 522,
	"./no-image-rect.png": 1747,
	"./no-image.png": 1748,
	"./profile_pic_grace.png": 1749,
	"./profile_pic_tara.png": 761,
	"./reamaze.png": 1750,
	"./salesforce_service_cloud.png": 1751,
	"./shopify.png": 1752,
	"./skin/database_add.png": 1753,
	"./skin/database_delete.png": 1754,
	"./skin/database_edit.png": 1755,
	"./skin/database_save.png": 1756,
	"./skin/database_table.png": 1757,
	"./skin/exclamation.png": 1758,
	"./skin/house.png": 1759,
	"./skin/information.png": 1760,
	"./stamped.png": 1761,
	"./tick.png": 1762,
	"./tiktok.png": 715,
	"./twitter.png": 709,
	"./yotpo.png": 1763,
	"./zendesk-chat.png": 762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1733;